<template>
    <v-main>
        <v-card flat class="px-2">
            <v-container>
                <v-col cols="10" xl="6" offset="1" offset-xl="3">
                    
                    <v-row class="pl-3">
                        <h2>Send damage claim</h2>
                        <v-spacer></v-spacer>
                        <v-btn :disabled="mailSend===true" class="primary mr-4 mt-2" small v-on:click="sendMail"><v-icon medium class="mr-2">{{ this.buttonIcon }}</v-icon>{{ this.buttonCaption }}</v-btn>
                    </v-row>
                    <v-divider class="mt-6 mb-2"></v-divider>  

                    <v-row dense>
                        <v-col cols="12">
                            <incident_header :col1="4" :col2="4" :isDense="true" :fontsize="'medium'" :incident="claim" @updateData="updateData"/>
                        </v-col>    
                    </v-row>
                    <v-row dense>
                        <v-col cols="12">
                            <incident_components :col1="4" :col2="4" :isDense="true" :amount="claim.claim_amount" :components="components"/>
                        </v-col>    
                    </v-row>   

                    <v-row class="mt-8">
                        <v-col cols="12">
                            <v-text-field dense label="E-mail address" v-model="claim.insurer_email" clearable class="mb-1">{{ this.claim.insurer_email }}</v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field dense label="Subject" v-model="claim.subject" clearable>{{ this.claim.subject }}</v-text-field>
                        </v-col>
                    </v-row>                    
                    <v-row dense>
                        <v-col cols="12">
                            <v-textarea v-model="mailtext" rows="4" label="Mail text">{{ this.claim.discription }}</v-textarea>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12">
                            <select_attachments :attachments="attachments" table="hosm" @updateData="updateData"/>
                        </v-col>    
                    </v-row>   

                </v-col>
            </v-container>
        </v-card>
        <navBar title="Ares - Send mail" :home="true"/>
        <standard_dialog ref="std_dialog" /> 
        <please_wait ref="wait" :isPersistent="true" display_text="Sending..." :timerInterval="500"/>
    </v-main>
</template>

<script>

import navBar from "@/components/ui/navbars/navbar.vue";
import standard_dialog from '@/components/ui/standard_dialog.vue';
import please_wait from '@/components/pleaseWait.vue'
import select_attachments from '@/components/ui/selectors/select_attachments.vue'
import incident_components from '@/components/huov/ui/hokl_hosm_mail_components.vue'
import incident_header from '@/components/huov/ui/hokl_hosm_mail_header.vue'

export default {    
    props: ['param'],
	components: {
        navBar,
        select_attachments,
        incident_components,
        standard_dialog,
        incident_header,
        please_wait
	},
    data () {
        return {
            hosm_encrid: '',
            claim: {},
            attachments: [],
            selected: [],
            components: [],
            mailtext: '',
            mailSend: false,
            preview: {},
            buttonCaption: 'Send mail',
            buttonIcon: 'mdi-email-fast-outline',      
            date_received_iso: ''      
        }
    },
    created() { // set up event bus listener here on created event or get data
        if (this.param != null) {
            this.params = this.param.split(":"); // 0 = huov, 1 = hosm
        }
    },    
    mounted() {
        this.getIncidentData();
    },          
    methods: {
        convertTextToHtml(text) {
            return text.replace(/\n/gi, '<br>'); // yes indeed, regular expression!!
        },
        sendMail() {
            this.$refs.wait.open();
            this.claim.description = this.convertTextToHtml(this.mailtext);
            if(this.date_received_iso !=='' && this.date_received_iso !==null){
                this.claim.date_received = this.$moment(this.date_received_iso).format('DD-MM-YYYY');
            }
            this.$axios
                .post("ares/json/ares/huov/hosm/sendClaim.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "sendClaim",
                    },
                    sendClaim: {
                        claim: this.claim,
                        attachments: this.selected,
                        components: this.components,
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        this.$refs.wait.close();
                        this.$refs.std_dialog.open('error', 'Error', res.data.error.message); 
                    } else {
                        this.mailSend=true;
                        this.buttonCaption='Mail sent';
                        this.buttonIcon='mdi-check-circle-outline';
                        this.$refs.wait.close();
                    }
                })
        },
        updateData(data){
            this[data.field] = data.value;
        },	          
        getIncidentData() {
            this.$axios
                .post("ares/json/ares/huov/hosm/getClaimDatav2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getClaimData",
                    },
                    getClaimData: {
                        hosm_encrid: this.params[1],
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error.message);
                    } else {
                        this.claim = res.data.claim;
                        this.attachments = res.data.attachments;
                        this.components = res.data.components;
                    }
                });
        },
    }
}
</script>

<style scoped>
</style>